
import { DAOExpanderFactoryABI } from "../../abis/DAOExpanderFactory.abi";
import { Web3ContractProvider, Web3ProviderExtras } from "../web3.provider";

import {
  DAOExpanderFactoryContractEventType,
  DAOExpanderFactoryContractFunctions,
  // @ts-ignore
} from "./sw-contract-functions";

const Web3DAOExpanderFactoryProvider = async (
  addressOrName: string,
  extras?: Partial<Web3ProviderExtras<DAOExpanderFactoryContractEventType>>
) => {
  return Web3ContractProvider<DAOExpanderFactoryContractEventType, DAOExpanderFactoryContractFunctions>(
    addressOrName,
    DAOExpanderFactoryABI,
    extras as Web3ProviderExtras<DAOExpanderFactoryContractEventType>
  );
};

export { Web3DAOExpanderFactoryProvider, DAOExpanderFactoryContractEventType, DAOExpanderFactoryContractFunctions };
